// extracted by mini-css-extract-plugin
module.exports = {"content":"e_X","pw-ad-scroll-container":"e_Y","pw-in-article":"e_Z"};